import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ProjectService } from '../shared/services/project/project.service';

export const PROJECT_ID_HEADER = 'x-project-id';

/**
 * Attaches the active project as an `x-project-id` header on every outgoing HTTP
 * request, so the backend can attribute an audit event to the project the change
 * was made in without any per-call wiring — the same trick
 * `langHeaderInterceptor` uses for the UI language.
 *
 * This is how a plant-scoped mutation (a sensor, a reception) becomes attributable
 * to a project: those entities belong to a plant, and nothing in their request body
 * says which project the user was working in.
 *
 * The header is **client-asserted**, which is why the backend stores it as
 * `source.requestProjectId` and never uses it for authorization — see
 * `AuditService.record`. Omitted when no project is open (admin screens), which
 * correctly leaves those mutations unattributed.
 */
export const projectHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const projectId = inject(ProjectService).currentProject()?.id;
  if (!projectId) return next(req);

  const cloned = req.clone({
    setHeaders: { [PROJECT_ID_HEADER]: projectId },
  });
  return next(cloned);
};
